"use client";
import React from 'react';
import HighlightedText from '../HighlightedText';
import { getStrapiMedia } from "../../lib/api-helpers";
import Image from 'next/image';

interface ResourcePageHeroProps {
    data: any;
}

const ResourcePageHero = (props: ResourcePageHeroProps) => {
    const { data } = props;
    const imgUrl = getStrapiMedia(data?.icon?.data?.attributes?.url);
    return (
        <section className="relative">
            <div
                className={`container relative mx-auto mt-[40px] md:mt-0 lg:mt-0 xl:mt-0 xl:px-0 px-6 flex items-center justify-center flex-col md:flex-row pb-[36px]`}>
                <div
                    className={`relative w-3/5 text-left flex flex-col items-start self-center xl:col-span-2`}>
                    <HighlightedText
                        text={data.title}
                        tag='h1'
                        className={`!leading-[1.2] text-4xl md:text-5xl lg:text-5xl xl:text-6xl mb-[16px]  w-full font-bold  text-[#032d60]`}
                    />
                    <HighlightedText
                        text={data.description}
                        tag='p'
                        className={`text-[18px] text-[#000000]`}
                    />
                </div>
                <div
                    className={`relative`}>
                    <Image
                        src={imgUrl ?? ""}
                        alt={"Resource Page Hero"}
                        className={`w-full  relative object-contain object-center md:h-auto lg:h-[450px] xl:h-[420px]`}
                        width={480}
                        height={480}
                        priority={true}
                        fetchPriority="high"
                    />
                </div>
            </div>
        </section>
    );
}

export default ResourcePageHero;